import React from 'react';
import { Input, Label, FormGroup, Form, Alert, Button, ButtonGroup, InputGroup } from 'reactstrap';
import { Popover } from '@mui/material';

export const TemplateSaveMultiplePopoverItem = props => {
    return (
        <Popover
            id={props.popoverURLAncor && 'simple-popover'}
            open={props.popoverURLAncor}
            anchorEl={props.popoverURLAncor}
            onClose={props.handlePopoverURLClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <div style={{ padding: 20 }}>
                <p style={{ fontSize: '.9rem' }}>Multiple templates have been changed</p>
                <ButtonGroup style={{ marginTop: 20 }}>
                    <Button color="primary" onClick={props.handleSaveAll}>
                        Save All
                    </Button>
                    <Button color="primary" onClick={props.handleSaveOne}>
                        Save One
                    </Button>
                    <Button color="danger" onClick={props.toggle}>
                        Close
                    </Button>
                </ButtonGroup>
            </div>
        </Popover>
    )
}